// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0d60a802]:export {\n  green: #67c892;\n  green-light: #9ec867;\n  yellow: #edc84c;\n  orange: #e9ad6a;\n  red: #e96a6a;\n  secondaryColor: #30415d;\n  primaryColor: #5dbfe2;\n  primaryColorDark: #4886a5;\n  gray: #a1a1a1;\n}\n.form-date-and-locations[data-v-0d60a802]  .multiselect {\n  font-size: 13px;\n}\n.form-date-and-locations[data-v-0d60a802]  .location-group-select .isInForm .multiselect__tags {\n  min-height: 120px;\n}", ""]);
// Exports
module.exports = exports;
